import {
  ApiPayloads,
  IndividualEntityAttributes,
  OrganizationEntityAttributes,
} from 'types/api-payloads';
import { RecursiveOmit } from 'types/utils';

type EntityPayload = ApiPayloads['entity']['payload'];

interface IndividualEntity extends EntityPayload {
  concreteEntityAttributes: Required<IndividualEntityAttributes>;
}

interface OrganizationEntity extends EntityPayload {
  concreteEntityAttributes: Required<OrganizationEntityAttributes>;
}

interface ImportedEntity extends EntityPayload {
  concreteEntityAttributes: {
    id: number | null;
    name: string | null;
  };
}

export type IndividualEntityForm = RecursiveOmit<IndividualEntity, '_destroy'>;
export type OrganizationEntityForm = RecursiveOmit<
  OrganizationEntity,
  '_destroy'
>;
export type ImportedEntityForm = RecursiveOmit<ImportedEntity, '_destroy'>;

export type PhoneAttributes = IndividualEntityForm['phoneNumbersAttributes'][0];

export type EmailAttributes =
  IndividualEntityForm['emailAddressesAttributes'][0];

export type AddressAttributes = IndividualEntityForm['addressesAttributes'][0];

export const organizationTypes = [
  'LLC',
  'Corporation',
  'General Partnership',
  'Limited Partnership',
  'Trust',
  'Life Estate',
  'JTWRS',
  'Marital Property',
  'State/Government Institution',
  'Church/Religious Institution',
] as const;
